var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: ['empty-tips', ("empty-tips-" + _vm.size)]
  }, [(_vm.size === 'tiny') ? _c('img', {
    attrs: {
      "src": require("images/empty-tiny.png"),
      "alt": "empty"
    }
  }) : _c('img', {
    attrs: {
      "src": require("images/empty.png"),
      "alt": "empty"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._t("default", [_vm._v("亲，该页面暂时没有内容！")])], 2)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e33ff2e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/empty.vue
// module id = null
// module chunks = 